import PropTypes from 'prop-types';
import React, { useEffect, useCallback } from 'react';
import { track } from '@xanadu/ui-shared/interfaces/woopra';
import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from './UploadDocumentsSuccess.module.scss';

const UploadDocumentsSuccess = ({ closeModal, userRegistered, depositRequest }) => {
  useEffect(() => {
    track('Registration', 'Upload Docs - Success');
  }, []);

  const handleOnClick = useCallback(() => {
    closeModal();

    let timer = null;

    if (userRegistered) {
      timer = setTimeout(() => {
        depositRequest();
      }, 400);
    }

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={styles.uploadSuccess}>
      <div className={styles.textContainer}>
        <span className={styles.textTop}>
          Thank You
        </span>
        <span className={styles.text}>
          Thank you for submitting your documents.
        </span>
        <span className={styles.text}>
          {'An email will be sent once complete. Please do not submit your documents again unless asked to do so. We aim to complete all document processing as swiftly as possible. Please bear with us while we undertake our necessary checks and processes.'}
        </span>
        <span className={styles.text}>
          Matchbook reserves the right to request further documentation in the future.
        </span>
      </div>
      <div className={styles.containerActions}>
        <Button
          sizeType="wider"
          buttonType="primary"
          onClick={handleOnClick}
        >Done</Button>
      </div>
    </div>
  );
};

UploadDocumentsSuccess.propTypes = {
  closeModal: PropTypes.func.isRequired,
  depositRequest: PropTypes.func.isRequired,
  userRegistered: PropTypes.bool.isRequired,
};

export default UploadDocumentsSuccess;

